import { useState } from 'react';
import { AxiosError } from 'axios';
import { getAppSettings } from '../api';
import { ISettingsGroups } from '../interfaces';

export function useGetAppSettings() {
  const [data, setData] = useState<ISettingsGroups | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function fetchSettings() {
    setLoading(true);
    try {
      const response = await getAppSettings();
      setData(response);
      setSuccess(true);
    } catch (error) {
      setSuccess(false);
      setError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  return { data, loading, success, error, setData, fetchSettings };
}
